/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Share_Tab_Pending1Inputs */

const en_coinvestments_share_tab_pending1 = /** @type {(inputs: Coinvestments_Share_Tab_Pending1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pending (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Pending ({count})" |
*
* @param {Coinvestments_Share_Tab_Pending1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_tab_pending1 = /** @type {((inputs: Coinvestments_Share_Tab_Pending1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Tab_Pending1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_tab_pending1(inputs)
});
export { coinvestments_share_tab_pending1 as "coInvestments_share_tab_pending" }